export default {
  rankOne: 'Dieser Interessenstyp passt am besten zu dir!',
  rankTwo: 'Dieser Interessenstyp passt am zweitbesten zu dir!',
  rankThree: 'Dieser Interessenstyp passt am drittbesten zu dir!',
  rankFour: 'Dieser Interessenstyp passt am viertbesten zu dir!',
  rankFive: 'Dieser Interessenstyp passt am fünftbesten zu dir!',
  rankSix: 'Dieser Interessenstyp passt am sechstbesten zu dir!',
} as any;
